import React from 'react';
import { SectionCta } from '../SectionCta';
import { painPoints } from '../../data/sections';
export function PainPoints() {
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-246" data-mp="1twgsyk0u7w5y">
      <div className="mx-auto max-w-5xl" data-id="element-247" data-mp="27mkbp10id7qn">
        <h2 className="text-center font-display text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-248" data-mp="27nlp3c4zy6bj">
          Does Any of This Sound Familiar?
        </h2>

        <ul className="mt-10 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-249" data-mp="2hjfazm4lvc5z">
          {painPoints.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="flex gap-4 border-t border-ice-line pt-6" data-id="element-250" data-mp="2cl5ffaeyy9ju">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-ice text-brand" data-id="element-251" data-mp="2qkmugy2gq8g0">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-252" data-mp="2mkct5ypm867h" />
              </span>
              <div data-id="element-253" data-mp="w7nkplkrk8gn">
                <h3 className="font-display text-[17px] font-extrabold leading-snug text-ink" data-id="element-254" data-mp="w985ijha0d1b">{title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-255" data-mp="s7wmwxwtks2m">{body}</p>
              </div>
            </li>)}
        </ul>

        <SectionCta label="Fix My Planning Process — $27" data-id="element-256" data-mp="1s7y3w313um50" />
      </div>
    </section>;
}